import * as types from 'constants/resume-info';

// download
import axios from 'axios';
import store from 'store';
import FileSaver from 'file-saver';

import { message , Modal } from 'antd';

import {AjaxByToken } from 'utils/ajax';
import { set } from 'lodash';

// 分享面试官列表功能的开发
const GET_EVALUATION_INTERVIEWS ={type:types.GET_EVALUATION_INTERVIEWS};

// 控制Echart的显示和隐藏
const SHOW_ECHARTS_STATUS ={type:types.SHOW_ECHARTS_STATUS};
const HIDE_ECHARTS_STATUS ={type:types.HIDE_ECHARTS_STATUS};
// 显示编辑简历model
const SHOW_RESUME_EDIT_MODEL ={type:types.SHOW_RESUME_EDIT_MODEL};
// 隐藏编辑简历model
const HIDE_RESUME_EDIT_MODEL = {type:types.HIDE_RESUME_EDIT_MODEL};

// 招聘人员详细信息
const LOAD_RESUME_INFO = {type:types.LOAD_RESUME_INFO};
// 开始获取招聘人员详细信息
const LOAD_INFO_START = {type:types.LOAD_INFO_START};
// 获取招聘人员详细信息结束
const LOAD_INFO_DONE = {type:types.LOAD_INFO_DONE};

// 显示Modal 确定按钮loading
const SHOW_MODAL_LOADING ={type:types.SHOW_MODAL_LOADING};
// 隐藏Modal 确定按钮loading
const HIDE_MODAL_LOADING = {type:types.HIDE_MODAL_LOADING};

// 下载简历
const DOWNLOAD_RESUME_START = {type:types.DOWNLOAD_RESUME_START};
const DOWNLOAD_RESUME_DONE = {type:types.DOWNLOAD_RESUME_DONE};
const DOWNLOAD_RESUME = {type:types.DOWNLOAD_RESUME};

const SHOW_MODAL = {type:types.SHOW_MODAL};
const HIDE_MODAL = {type:types.HIDE_MODAL};

const SHOW_SHARE_MODAL = {type:types.SHOW_SHARE_MODAL};
const HIDE_SHARE_MODAL = {type:types.HIDE_SHARE_MODAL};


//面试评估表
const SHOW_INTERVIEW_EVALUATION_MODAL = {type:types.SHOW_INTERVIEW_EVALUATION_MODAL};
const HIDE_INTERVIEW_EVALUATION_MODAL = {type:types.HIDE_INTERVIEW_EVALUATION_MODAL};

//添加面试评估
const GET_EVALUATION = {type:types.GET_EVALUATION};

//添加面试评估ID
const GET_EVALUATION_ID = {type:types.GET_EVALUATION_ID};

//背景调查
const SHOW_BACKGROUNDSURVEY_MODAL = {type:types.SHOW_BACKGROUNDSURVEY_MODAL};
const HIDE_BACKGROUNDSURVEY_MODAL = {type:types.HIDE_BACKGROUNDSURVEY_MODAL};

//简历信息分享
const RESUME_INFORMATION = {type:types.RESUME_INFORMATION}

//简历信息
const RESUME_INFO = {type:types.RESUME_INFO}
// 面试信息
const INTERVIEW_INFO = {type:types.INTERVIEW_INFO}

//loading
const FILL_LOADING = {type:types.FILL_LOADING}

//分享链接MOdal
const SHOW_QRCODE_LINKMODAL = {type:types.SHOW_QRCODE_LINKMODAL}
const HIDE_QRCODE_LINKMODAL = {type:types.HIDE_QRCODE_LINKMODAL}

// 面试的分数和面试的结论
const SCORES = {type:types.SCORES}
const SUMMARY = {type:types.SUMMARY}
// 点击同时申请将标签默认为选中第一个
const TYPE ={type:types.TYPE};
// 保存临时的变量(基本信息)
const TEMP_BACICINFO  = {type:types.TEMP_BACICINFO}
const TEMP_INTENTION = {type:types.TEMP_INTENTION}
const TEMP_ASSESSMENT = {type:types.TEMP_ASSESSMENT}
const TEMP_EDUCLIST = {type:types.TEMP_EDUCLIST}
const TEMP_PROJECT_LIST = {type:types.TEMP_PROJECT_LIST}
const TEMP_WORK_LIST = {type:types.TEMP_WORK_LIST}
const TEMP_LAN_LIST = {type:types.TEMP_LAN_LIST}
const TEMP_TRAIN_LIST = {type:types.TEMP_TRAIN_LIST}
const TEMP_CERT_LIST = {type:types.TEMP_CERT_LIST}
const TEMP_OTHER_LIST ={type:types.TEMP_OTHER_LIST}
const TEMP_BORNDATA =  {type:types.TEMP_BORNDATA}
const TEMP_ADVAR={type:types.TEMP_ADVAR}

const TEMP_ADVAR_FILEPATH={type:types.TEMP_ADVAR_FILEPATH}


export const clearUpAdvar = () => (dispatch,getState) => {
    
    dispatch({...TEMP_ADVAR,tempAdvar:''});
   
}

  // 上传修改头像
export const upAdvar = (file) => (dispatch,getState) => {
    const token = store.get('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tokenKey', token.tokenKey);
    formData.append('token', token.token);
    axios({
        url: `${prefixUri}/uploadrheadimg`,
        method: 'post',
        data:formData
    })
    .then(res=>{
    
      dispatch({...TEMP_ADVAR,tempAdvar:res.data.result.headimg});
      dispatch({...TEMP_ADVAR_FILEPATH,tempAdvarFilepath:res.data.result.headimg});
      
     
    }).catch(error=>{
        message.info("上传失败")
    });
}

//   // 上传删除头像
  export const removeUpAdvar = (value) => (dispatch,getState) => {
 
    AjaxByToken('delrheadimg',{
        head: {
            transcode: 'L0122'
        },
        data:{
            headimg:value
        }
    })
    .then(res=>{
       
     },err=>{
    });


 }




 //储存临时edit个人的基本的信息
export const tempbasicInfo = (data) => (dispatch,getState) => {
    dispatch({...TEMP_BACICINFO,tempResumeInfo:data});
}
// 储存生日的日期的临时值
export const tempborndate = (data) => (dispatch,getState) => {
    dispatch({...TEMP_BORNDATA,tempborndate:data});
}

export const tempIntention = (data) => (dispatch,getState) => {
    dispatch({...TEMP_INTENTION,tempIntention:data});
}
export const tempAssessment = (data) => (dispatch,getState) => {
    dispatch({...TEMP_ASSESSMENT,tempAssessment:data});
}
// 教育经历
export const tempEducList = (data) => (dispatch,getState) => {
    dispatch({...TEMP_EDUCLIST,tempEducList:data});
}
// 项目经验
export const tempProjectlist = (data) => (dispatch,getState) => {
    dispatch({...TEMP_PROJECT_LIST,tempProjectlist:data});
}
// 工作经验
export const tempWorklist = (data) => (dispatch,getState) => {
    dispatch({...TEMP_WORK_LIST,tempWorklist:data});
}
// 语言能力
export const tempLanlist= (data) => (dispatch,getState) => {
    dispatch({...TEMP_LAN_LIST,tempLanlist:data});
}
// 培训经历
export const tempTrainlist= (data) => (dispatch,getState) => {
    dispatch({...TEMP_TRAIN_LIST,tempTrainlist:data});
}
// 证书
export const tempCertlist= (data) => (dispatch,getState) => {
    dispatch({...TEMP_CERT_LIST,tempCertlist:data});
}
// 其他
export const tempOtherlist= (data) => (dispatch,getState) => {
    dispatch({...TEMP_OTHER_LIST,tempOtherlist:data});
}



//得到招聘流程人员详细信息(根据简历id和流程id)
export const getRecruitResumeInfo = (data) => (dispatch,getState) => {
    /**
     * resumeId: resumeId,
     * logId: logId
     */
    dispatch(LOAD_INFO_START);
    AjaxByToken('getResumeById',{
        head: {
            transcode: 'L0017'
        },
        data: data
    })
    .then(res=>{
        dispatch(LOAD_INFO_DONE);
        dispatch({...LOAD_RESUME_INFO,resumeInfo:res});
     
    });
}

//简历编辑接口
export const submitEditResumeInfo = (data,hideResumeEditModal,logId,getRecruitResumeInfo,getTalentResumeInfo) => (dispatch,getState) => {
    /**
     * resumeId: resumeId,
     * logId: logId
     */
    AjaxByToken('updateresume',{
        head: {
            transcode: 'L0115'
        },
        data: data
    })
    .then(res=>{
        message.info("编辑简历提交成功")
        if(logId==undefined){
            setTimeout( ()=> {
                getTalentResumeInfo({
                    resumeid: data.resumeInfo.resumeid,
                })
                hideResumeEditModal()
              }, 1000);
            
        }else{
            setTimeout( ()=> {
                getRecruitResumeInfo({
                    resumeId: data.resumeInfo.resumeid,
                    logId: logId
                })
                hideResumeEditModal()
              }, 1000);
        }
    });
}

// 对单个候选人的简历进行导入

// 获取面试信息(简历id 和职位 id)
export const getInterviewInfo = (data) => (dispatch,getState) => {
    dispatch(LOAD_INFO_START);
    AjaxByToken('intepinfo',{
        head: {
            transcode: 'L0100'
        },
        data
       
    })
    .then(res=>{
     
        dispatch(LOAD_INFO_DONE);
        if(res.result!=null){
            dispatch({...INTERVIEW_INFO,interviewInfo:res.result});
            dispatch({...TYPE,type:4});
            if(data.type){
                window.print()
            }
           }else{
            dispatch({...INTERVIEW_INFO,interviewInfo:{}}); 
            dispatch({...TYPE,type:4});
            if(data.type){
                window.print()
            }
           }
     
    },err=>{
        dispatch(LOAD_INFO_DONE);
    });
}
// 下载原始简历

//获取面试结果和结论(resumeid+positionid)
export const getResult = (data,list) => (dispatch,getState) => {
    dispatch(LOAD_INFO_START);
    AjaxByToken('getgram',{
        head: {
            transcode: 'L0099'
        },
       data:data
    })
    .then(res=>{
        dispatch(LOAD_INFO_DONE);
        if(res.result!=null){
            list.map((obj,idx)=>{
                obj.fraction = (res.result.scores)[idx]
                return obj
              })
            let dignityList = list.sort(function(a,b){
                return b.fraction-a.fraction
            })
            dispatch({...SCORES,scores:res.result.scores,dignityList:dignityList});
            dispatch({...SUMMARY,summary:res.result.summary});
            dispatch({...TYPE,type:5});
        }else{
            dispatch({...TYPE,type:5});
        }
        if(data.type){
            setTimeout(() => {
                window.print()
             }, 1000)
        }
      
    },err=>{
        dispatch(LOAD_INFO_DONE);
    });
}
export const changeType = () => (dispatch,getState) => {
   dispatch({...TYPE,type:0});
   setTimeout(() => {
    window.print()
   }, 200);
 
}


// 获取流程log(根据简历id和职位id)
export const getStageLog = (data) => (dispatch,getState) => {
    dispatch(LOAD_INFO_START);
    AjaxByToken('detailsByPosition',{
        head: {
            transcode: 'L0019'
        },
        data: data
    })
    .then(res=>{
        dispatch(LOAD_INFO_DONE);
        dispatch({...LOAD_RESUME_INFO,resumeInfo:res});
        dispatch({...TYPE,type:0});
    })
}
// 根据简历id查询具体信息
export const getTalentResumeInfo = (data) => (dispatch,getState) => {
    dispatch(LOAD_INFO_START);
    AjaxByToken('resumeView',{
        head: {
            transcode: 'L0040'
        },
        data: data
    })
    .then(res=>{
        dispatch(LOAD_INFO_DONE);
        dispatch({...LOAD_RESUME_INFO,resumeInfo:res});
     },err=>{
    });
}

// 下载简历
export const downloadResume = (data,username) => (dispatch,getState) => {
    dispatch(DOWNLOAD_RESUME_START);
    const token = store.get('token');
    axios({
        url: `${prefixUri}/downloadResume`,
        method: 'post',
        data: {data:{...token,...data},...{
            head:{
                type:'h',
                transcode: 'L0023'
            }
        }},
        header: {
            contentType: 'application/json;charset=utf-8'
        },
    })
    .then(res=>{
        NProgress.done();
        const {data} = res;
        var blob = new Blob([data],{type: "text/html;charset=utf-8"});
        FileSaver.saveAs(blob ,`${username}的个人简历.html`);
        dispatch(DOWNLOAD_RESUME_DONE);
    });
}
// 查询面试信息的面试情况


// 更改流程状态
export const changeStageStatus = (data,props) => (dispatch,getState) => {
    dispatch(SHOW_MODAL_LOADING);
    AjaxByToken('changeStageStatus',{
        head: {
            transcode: 'L0020'
        },
        data: data
    })
    .then(res=>{
        dispatch(HIDE_MODAL_LOADING);
        // 隐藏Modal
        dispatch(HIDE_MODAL);
        const {currentStage,getStageLog} = props;
        const {positionid,resumeid} = currentStage;
        getStageLog({
            positionId: positionid,
            resumeId: resumeid,
        });
        window.parent.postMessage('rerequest','*');
    },err=>{
        dispatch(HIDE_MODAL_LOADING);
    });
}
//获取个人简历详细信息
export const getResumeInfo = (query) => (dispatch,getState) => {
    
    axios({
        url: `${prefixUri}/share/shareResume`,
        method: 'post',
        data: {data:{params:query},...{
            head:{
                type:'h',
                transcode: 'L0092'
            }
        }},
        header: {
            contentType: 'application/json;charset=utf-8'
        },
    })
    .then(res=>{
        dispatch({...RESUME_INFO,resumeInformation:res.data});
        if(res.data.returnMsg=="该链接已超时!请重新分享。"){
            Modal.warning({
            title: '链接已过期，请重新获取！',
            okText:"确定",
            style:{top:200}
            })
        }
        
    },err=>{
        
    });
}
//邀请他人填写面试评估
export const fillEvaluation = (query,resform) => (dispatch,getState) => {
    axios({
        url: `${prefixUri}/share/evaluationEdit`,
        method: 'post',
        data: {data:{params:query},...{
            head:{
                type:'h',
                transcode: 'L0093'
            }
        }},
        header: {
            contentType: 'application/json;charset=utf-8'
        },
    })
    .then(res=>{
        dispatch({...FILL_LOADING});
        if(res.data.returnMsg=="该链接以超时!请重新获取链接。"){
            Modal.warning({
            title: '链接已过期，请重新分享！',
            okText:"确定",
            style:{top:330}
            })
            return false
        }else{
            Modal.success({
                title: '成功添加评估表！',
                okText:"确定",
                style:{top:330}
            })
        } 
    },err=>{
        dispatch({...FILL_LOADING})
        Modal.error({
            title: '添加评估表失败！',
        });
    });
}

//简历分享参数
export const getResumeUrl = (data) => (dispatch,getState) => {
    AjaxByToken("employeeinfo/resumeUrl",{
        head:{
            transcode:"L0064"
        },
        data: data
    })
    .then(res=>{
        dispatch({...RESUME_INFORMATION,resumeUrl:res})
    },err=>{
        message.error('获取简历参数失败！');
    })
}

//添加面试评估
export const addEvaluation = (data,props) => (dispatch,getState) => {
    AjaxByToken('evaluationEdit',{
        head: {
            transcode: 'L0063'
        },
        data: data
    })
    .then(res=>{
        const {getRecruitResumeInfo,resumeid,logId} = props;
        getRecruitResumeInfo({
            resumeId: resumeid,
            logId: logId
        })
        if (data.id){
            message.success('修改评估表成功！');
        } else {
            message.success('添加评估表成功！');
        }       
    },err=>{
        if (data.id){
            message.error('修改评估表失败！');
        } else {
            message.success('添加评估表失败！');
        }  
    });
}

//获取评估表内容
export const getEvaluation = (data) => (dispatch,getState) => {
    AjaxByToken('employeeinfo/getResumeEvaluationById',{
        head: {
            transcode: 'L0066'
        },
        data: data,
         header: {
            contentType: 'application/json;charset=utf-8'
        },
    })
    .then(res=>{
      
        dispatch({...GET_EVALUATION,evaluation:res.evaluation[0]})
    },err=>{
        message.error('获取评估表失败！');
    });
}
//获取所有面试官列表
export const getAllInterviews = (data) => (dispatch,getState) => {
    dispatch(LOAD_INFO_START);
    AjaxByToken('intefb',{
        head: {
            transcode: 'L0107'
        },data:data
    })
    .then(res=>{
        dispatch(LOAD_INFO_DONE);
        dispatch({...GET_EVALUATION_INTERVIEWS,evaluationInterviews:res.result})
        
    },err=>{
        dispatch(LOAD_INFO_DONE);
        ;
    });
}




export const showModal = (data) => (dispatch,getState) => {
    dispatch({...SHOW_MODAL,currentStage:data});
}

export const hideModal = () => (dispatch,getState) => {
    dispatch(HIDE_MODAL);
}

export const showShareModal = (data) => (dispatch,getState) => {
    dispatch({...SHOW_SHARE_MODAL,resumeData:data});
}

export const hideShareModal = () => (dispatch,getState) => {
    dispatch(HIDE_SHARE_MODAL);
}

export const showEvaluationModal = (data) => (dispatch,getState) => {
    dispatch({...SHOW_INTERVIEW_EVALUATION_MODAL,evaluationData:data});
}

export const hideEvaluationModal = () => (dispatch,getState) => {
    dispatch(HIDE_INTERVIEW_EVALUATION_MODAL);
}

export const showBackgroundModal = (data) => (dispatch,getState) => {
    dispatch({...SHOW_BACKGROUNDSURVEY_MODAL,evaluationData:data});
}

export const hideBackgroundModal = () => (dispatch,getState) => {
    dispatch(HIDE_BACKGROUNDSURVEY_MODAL);
}

export const showQrcodeLinkModal = (data) => (dispatch,getState) => {
    dispatch({...SHOW_QRCODE_LINKMODAL,companyInfo:data});
}

export const hideQrcodeLinkModal = () => (dispatch,getState) => {
    dispatch(HIDE_QRCODE_LINKMODAL);
}
// 显示编辑简历弹框
export const showResumeEditModal = () => (dispatch,getState) => {
    dispatch(SHOW_RESUME_EDIT_MODEL);
}
// 隐藏编辑简历弹框
export const hideResumeEditModal = () => (dispatch,getState) => {
    dispatch(HIDE_RESUME_EDIT_MODEL);
}



// WEBPACK FOOTER //
// ./src/actions/resume-info.js